module.exports = __webpack_public_path__ + "img/bg_checkin.a49ac6ff.jpg";